module.exports = __webpack_public_path__ + "img/index_kyzx_znjs.534c0ec3.png";